import { KrCard } from '@/common/card/KrCard';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { McdStateProgressChart } from '../charts/McdStateProgressChart';

export const McdInvDashboardMapView = ({ formValues, endDateToStartDate }) => {
  return (
    <SpacerLayout>
      <Spacer>
        <KrCard title="Quarterly Invoice Progress by State" variant="soft">
          <McdStateProgressChart formValues={formValues} endDateToStartDate={endDateToStartDate} />
        </KrCard>
      </Spacer>
    </SpacerLayout>
  );
};
